import { useEffect } from 'react';
import { useCurrentUser } from '@hooks/useCurrentUser';
import { setCurrentReferralCode } from '@lib/referralCode';

/**
 * Keeps the module-level referral-code provider (@lib/referralCode) in sync
 * with the signed-in user, so getShareUrl can append `ref=` without being a
 * hook. Renders nothing.
 *
 * AIDEV-NOTE: Must live inside RootLayout's provider tree (not index.tsx):
 * useCurrentUser needs the Logto adapter context and useLocation's router
 * context, both of which only exist under <RootLayout/>.
 */
export const ReferralCodeSync = (): null => {
  const { user } = useCurrentUser();
  const referralCode = user?.referral_code ?? null;

  useEffect(() => {
    setCurrentReferralCode(referralCode);
    return () => {
      setCurrentReferralCode(null);
    };
  }, [referralCode]);

  return null;
};
